import { format } from 'date-fns';
import {
  DATE_EUROPEAN_MONTH_FORMAT,
  DATE_TIME_YEAR_24_HOUR_SECONDS_FORMAT,
} from '../util/dateFns';
import parseAsDate from '../util/parseAsDate';

// If the input value seems to be a timestamp, give it back as MM/dd.
export function conditionallyFormatAsDate(value: any) {
  return parseAsDate(value)
    ? format(new Date(value), DATE_EUROPEAN_MONTH_FORMAT)
    : value;
}

export function conditionallyFormatAsDateTime(value: any) {
  return parseAsDate(value)
    ? format(new Date(value), DATE_TIME_YEAR_24_HOUR_SECONDS_FORMAT)
    : value;
}

export type LineChartDataInstance = {
  x?: string | null;
  y?: number;
  line?: string | null;
};

export const j1QLResultsToLineChartData = (
  data: any[][]
): [any[], string[]] => {
  const newDataMap: any = {};
  const yKeys: string[] = [];
  data.forEach((d: any) =>
    d.forEach((item: LineChartDataInstance) => {
      const { line, x, y = 0 } = item;
      if (line !== undefined && line !== null && !yKeys.includes(line)) {
        yKeys.push(line);
      }
      if (
        x !== undefined &&
        x !== null &&
        line !== undefined &&
        line !== null
      ) {
        const formattedX = parseAsDate(x)?.getTime() || x;
        newDataMap[formattedX] = { ...newDataMap[x], x: formattedX, [line]: y };
      }
    })
  );

  return [
    Object.keys(newDataMap)
      .map((key) => newDataMap[key])
      .sort((a, b) => a.x - b.x),
    yKeys,
  ];
};
